import React from 'react';
import TooltipsWithTruncate from '../Tooltips/TooltipsWithTruncate';
import './chip.css';

interface ChipToolTip {
  tooltipText?: string;
  text: string;
  chipClass?: string;
  isHiddenTooltip?: boolean;
}
const ChipToolTip = ({ tooltipText, text, chipClass, isHiddenTooltip }: ChipToolTip) => {
  return (
    <TooltipsWithTruncate
      tooltips={tooltipText ?? ''}
      classCustom={`tooltipsWithTruncateBgGray ${isHiddenTooltip ? 'd-none' : ''} `}
      overlayProps={{ placement: 'bottom' }}
    >
      <span className={`chip fs-11 text-truncate text-center ${chipClass}`}>{text}</span>
    </TooltipsWithTruncate>
  );
};

export default ChipToolTip;
